import psl_ui from '../../libs/psl_ui.js';
import {wait} from '../../libs/psl_polyfills.js';

import audio from '../../components/audio.js';
import instructions from '../../components/instructions/component.js';

import './style.scss';
import template from './template.pst';
import card_template from './card.pst';

import message from '../../components/message/component.js';

psl_ui.templates.add('page_matching',template);
psl_ui.templates.add('page_matching_card',card_template);

const {el,rpoints}=psl_ui.templates.render('page_matching');

rpoints.finish.addEventListener('click',()=>{
	_ext.hide();
	if(_clb) _clb();
});

let _cards=[];

let _latest_card;

for(let i=0;i<12;i++){
	let type = Math.floor(i/2).toString();
	const card=psl_ui.templates.render('page_matching_card',{type}).el;
	card._type = type;
	card.addEventListener('click',()=>{
		_unblur(false);
		_click(card);
	});
	card.addEventListener('focus',()=>{
		_latest_card = card;
	});
	_cards.push(card);
}

window.addEventListener('resize',()=>{
	if(!el.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/1080;
		height=height/1920;
	}

	coef = Math.min(width,height);

	rpoints.container.style.transform=`scale3d(${coef},${coef},1)`;
}

const _types=[
	'Crosswalk signal',
	'Stop sign',
	'Pedestrian crossing sign',
	'Yield sign',
	'Crosswalk',
	'Crosswalk button'
];

const _result_mgs=[
	"Follow the instructions on the signal. Don't cross when you see a hand up like this. Instead, wait for the walk symbol.",
	"Look for stop signs and be sure that cars are stopping.",
	"Look for crosswalk signs, helping you know the best place to cross the street.",
	"Always yield and look both ways when crossing. Sometimes drivers don't see you or they're not paying attention.",
	"If it’s available, cross at a painted crosswalk where there are lines in the road.",
	"If available, push the crosswalk button to give you a safe space to cross."
];

let _clb;

let _keydown;

const _unblur = (v=true)=>{
	rpoints.game_board.classList.remove('blur');
	_cards.forEach(card=>{
		card.removeAttribute('tabindex');
		card.removeAttribute('aria-hidden');
	});
	if(v) _cards[0].focus();

	if(!_keydown){
		_keydown = e=>{
			let index = _cards.indexOf(_latest_card);
			switch(e.keyCode){
				case 37: //left
					index-=1;
				break;
				case 38: //up
					index-=4;
				break;
				case 39: //right;
					index+=1;
				break;
				case 40: //down
					index+=4;
				break;
				default:
					return;
			}

			if(index<0) index+=12;
			if(index>11) index-=12;

			_cards[index].focus();
		};
		window.addEventListener('keydown',_keydown);
	}
}

const init = (clb)=>{
	instructions.text='Flip the card to see things you might find at a crosswalk. Can you find matching pairs?';
	instructions.append(rpoints.container,_unblur);
	rpoints.game_board.classList.add('blur');

	rpoints.result.classList.add('hidden');
	rpoints.finish.classList.add('hidden');
	rpoints.finish.setAttribute('tabindex','-1');
	rpoints.finish.setAttribute('aria-hidden','true');

  _cards = _cards.sort(()=>(Math.random()-0.5));

	_cards.forEach((card,i)=>{
		card.setAttribute('aria-hidden','true');
		card.setAttribute('tabindex','-1');
		card.className='card';
		card.setAttribute('aria-label',`${i+1} unflipped card`);
		rpoints.game_board.appendChild(card);
	});

	flipped = undefined;

	_clb=clb;
}

const _flip_back = async card => {
	if(card.classList.contains('cnrrect')) return;
	card.classList.remove('incorrect');
	await wait(1);
	card.classList.remove('flipped');
	card.setAttribute('aria-label',`${_cards.indexOf(card)+1} unflipped card`);
}

let flipped;
const _click = async card => {
	instructions.hide();
	if(card.classList.contains('flipped')) return;

	_cards.filter(_card=>_card.classList.contains('flipped')&&_card.classList.contains('incorrect')&&_card!==flipped).forEach(_flip_back);

	card.classList.add('flipped');
	card.setAttribute('aria-label',_types[card._type]);

	audio.play('card_flip',{volume:0.8});
	if(!flipped){
		flipped = card;
		return;
	}

	const cards = [flipped,card];
	flipped = undefined;
	if(cards[0]._type===cards[1]._type){
		//correct
		_show_result(true,+cards[0]._type);
		await wait(375);
		cards.forEach(card=>{
			card.classList.add('correct');
		});

		if(_cards.find(card=>!card.classList.contains('correct'))){
			audio.play('correct');
		} else {
			audio.play('finished');
			rpoints.finish.classList.remove('hidden');
			rpoints.finish.removeAttribute('tabindex');
			rpoints.finish.removeAttribute('aria-hidden');
			instructions.remove();
		}

	} else {
		//incorrect
		_show_result(false,+cards[0]._type);
		audio.play('bounce');
		await wait(375);
		cards.forEach(card=>{
			card.classList.add('incorrect');
		});

		await wait(850);

		cards.forEach(_flip_back);
	}
}

const _show_result = async (correct,index)=>{
	rpoints.result.removeAttribute('aria-live');
	if(!rpoints.result.classList.contains('hidden')){
		rpoints.result.classList.add('hidden');
		await wait(250);
	}

	if(correct){
		rpoints.result.classList.remove('incorrect');
		rpoints.result_header.innerHTML='Correct!';
		message.show(`Correct! ${_result_mgs[index]}`);
		rpoints.result_text.innerHTML=_result_mgs[index];
		rpoints.result_img.className=`front t${index}`;
	} else {
		rpoints.result.classList.add('incorrect');
		rpoints.result_header.innerHTML='Sorry, Try again!';
		message.show('Sorry, Try again!');
		rpoints.result_text.innerHTML='';
		rpoints.result_img.className=`front`;
	}
	rpoints.result.classList.remove('hidden');
	await wait(250);
	rpoints.result.setAttribute('aria-live','polite');
}

const _ext={
	show:({
		parent,
		clb
	})=>{
		parent.insertBefore(el,parent.firstChild);
		_resize();
		init(clb);
	},
	hide:()=>{
		if(el.parentNode) el.parentNode.removeChild(el);
		if(_keydown){
			window.removeEventListener('keydown',_keydown);
			_keydown = undefined;
		}
	}
}

export default _ext;
